require('../bootstrap');
import * as func from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {
    const newsletter = {
        isLoading: false,
        init() {
            $(document).on('click', '.subscribe-to-newsletter-btn', this, this.save);
        },
        save(event) {
            const _this = event.data;
            
            if (_this.isLoading) {
                return false;
            }
            $('#newsletter-email').removeClass('is-invalid');
            $('#newsletter-privacy-policy').removeClass('is-invalid');
            var errors = false;

            if ($('#newsletter-email').val() == '') {
                $('#newsletter-email').addClass('is-invalid');
                errors = true;
            }
            if (!$('#newsletter-privacy-policy').is(':checked')) {
                $('#newsletter-privacy-policy').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return;
            }

			//Loading...
            _this.isLoading = true;

            var values = '_token=' + $("meta[name=csrf-token]").attr('content');
			values += '&email=' + $('#newsletter-email').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/newsletter/send`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;
                    $('#newsletter-email').val('');
                    $('#newsletter-privacy-policy').prop("checked", false) ;

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#newsletter-' + errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						Swal.fire({
							//icon: 'success',
							title: 'Eroare!',
							html: errorHtml
						});
                        return;
                    }

                    if (response.status == 1) {
						Swal.fire({
                            //icon: 'success',
                            title: 'Success!',
                            html: response.message
                        });
                        return;
					}

                    Swal.fire({
                        //icon: 'success',
                        title: 'Eroare!',
                        html: response.message
                    });
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
		}
    };

    if ($('.subscribe-to-newsletter-btn').length) {
        newsletter.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/newsletter.js